import {Component, inject, OnInit} from '@angular/core';
import { HasPermissionDirective } from '@shared/directives/has-permission.directive';
import {LabelComponent} from '../../../../../../shared/components/form/label/label.component';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {CreationButtons} from '../../../../../../shared/components/ui/creation-buttons/creation-buttons';
import {ErrorService} from '../../../../../../shared/services/error.service';
import {SnackbarService} from '@shared/services/snackbar.service';
import {ContactosService} from '../contactos.service';
import {DatePipe} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CombosService} from '../../../../../../shared/services/combos.service';
import {GenericCombo} from '../../../../../../shared/services/interfaces/combos.interface';
import {forkJoin} from 'rxjs';
import {SelectFieldComponent, SelectOption} from '@shared/components/form/select/select-field.component';
import {TextareaFieldComponent} from '@shared/components/form/textarea/textarea-field.component';
import {InputFieldComponent} from '@shared/components/form/input/input-field.component';
import { AppFormComponent } from '@shared/components/ui/list-components';
import { Modal } from '@shared/components/common/modal/modal';

@Component({
  selector: 'app-crear-contacto',
  imports: [
    HasPermissionDirective,
    LabelComponent,
    FormsModule,
    ReactiveFormsModule,
    CreationButtons,
    SelectFieldComponent,
    TextareaFieldComponent,
    InputFieldComponent,
    AppFormComponent,
    Modal,
  ],
  providers: [DatePipe],
  templateUrl: './crear-contacto.html',
  styles: ``
})
export class CrearContacto implements OnInit {

  saveForm!: FormGroup;
  loading = false;
  today = new Date();
  canalesContactos: GenericCombo[] = [];
  motivosContacto: GenericCombo[] = [];
  campanhas: GenericCombo[] = [];
  estadosContactos: GenericCombo[] = [];

  get canalesContactosOptions(): SelectOption[] {
    return this.canalesContactos.map(c => ({ value: c.id, label: c.nombre }));
  }

  get motivosContactoOptions(): SelectOption[] {
    return this.motivosContacto.map(c => ({ value: c.id, label: c.nombre }));
  }

  get campanhasOptions(): SelectOption[] {
    return this.campanhas.map(c => ({ value: c.id, label: c.nombre }));
  }

  get estadosContactosOptions(): SelectOption[] {
    return this.estadosContactos.map(c => ({ value: c.id, label: c.nombre }));
  }

  private fB = inject(FormBuilder);
  private contactosService = inject(ContactosService);
  private combosService = inject(CombosService);
  private errorService = inject(ErrorService);
  private snackbarService = inject(SnackbarService);
  private datePipe = inject(DatePipe);
  private dialogRef = inject(MatDialogRef<CrearContacto>);
  private idProspecto = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.getCombos();
    this.makeForm();
  }

  private getCombos(): void {
    const canalesContactos = this.combosService.getCanalContactoCombo();
    const motivosContacto = this.combosService.getMotivoContactoCombo();
    const campanhas = this.combosService.getCampanhasCombo();
    const estadosContactos = this.combosService.getEstadoContactoCombo();

    forkJoin([canalesContactos, motivosContacto, campanhas, estadosContactos]).subscribe({
      next: (response) => {
        this.canalesContactos = response[0].data;
        this.motivosContacto = response[1].data;
        this.campanhas = response[2].data;
        this.estadosContactos = response[3].data;
      }, error: (error) => {
        this.errorService.handleError(error);
      }
    });
  }

  private makeForm(): void {
    this.saveForm = this.fB.group({
      crm_prospecto_id: [this.idProspecto, Validators.required],
      param_canal_contacto_id: ['', Validators.required],
      param_motivo_contacto_id: ['', Validators.required],
      crm_campanha_id: ['', Validators.required],
      param_estado_contacto_id: ['', Validators.required],
      fecha: [this.datePipe.transform(this.today, 'yyyy-MM-ddTHH:mm'), Validators.required],
      resultado: ['', Validators.required],
    });
  }

  create(): void {
    this.loading = true;
    const fecha = this.normalizeFechaParaApi(this.saveForm.get('fecha')?.value);
    const jsonData = {
      ...this.saveForm.value,
      fecha
    }

    this.contactosService.store(jsonData).subscribe({
      next: (response) => {
        if (response.status) {
          this.snackbarService.showSnackBar('Contacto creado correctamente');
          this.dialogRef.close(true);
        }
      }, error: (error) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.loading = false;
    });
  }

  cancel(): void {
    this.saveForm.reset();
    this.dialogRef.close();
  }

  private normalizeFechaParaApi(value: string | Date | null | undefined): string | null {
    if (!value) return null;
    if (typeof value === 'string') {
      return value.replace('T', ' ');
    }
    return this.datePipe.transform(value, 'yyyy-MM-dd HH:mm');
  }
}
